import React, { useState, useEffect } from 'react';
import { Button, Box, ButtonGroup, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';

const ManagementKelasPage = () => {
  const navigate = useNavigate(); 
  // const [booking, setBooking] = useState([]);
  // const [changeBooking, setChangeBooking] = new useState('');

  // const fetchListBooking = () => {
  //   fetch('http://localhost:3000/booking/get-list-booking', {
  //       method: 'GET',
  //       })
  //        .then((response) => response.json())
  //        .then(
  //         (data) => {
  //           setBooking(data)
  //         },
  //         (error) => {
  //           console.log(error)
  //         }
  //       )
  // }

  // useEffect(() => {
  //   fetchListBooking();
  // }, [changeBooking]);
  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Typography sx={{ fontFamily: 'Titillium Web',marginLeft: '280px' , mt: 2, fontWeight: 'bold' }} variant="h6" component="h3" color="#1C1C1E" mb={1}>
          Manajemen Booking
      </Typography>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Booking Kelas" />
      </Box>
      <Box sx={{ fontFamily: 'inherit' }}>

      <Box sx={{ marginLeft: '280px', marginRight: '10px' }} display="flex" justifyContent="space-between" mb={2}>
      <TableContainer component={Paper} sx={{fontFamily: 'Titillium Web', maxHeight: '600px'}}>
        <Table aria-label='Daftar Booking' stickyHeader>
          <TableHead>
          {/* <TableRow>Daftar Booking</TableRow> */}
          <TableRow>
              <TableCell>No</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Kode Referal</TableCell>
              <TableCell>Tanggal</TableCell>
              <TableCell>Jam Booking</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              bookingData.map(row => (
                <TableRow key={row.id} sx={{'&:last-child td, &:last-child th': {border:0}}}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.username}</TableCell>
                  <TableCell>{row.referal}</TableCell>
                  <TableCell>{row.tanggalBooking}</TableCell>
                  <TableCell>{row.jamBooking}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell>
                  <ButtonGroup variant="outlined" aria-label="outlined button group">
                    <Button variant="contained" color="success">Info</Button>
                    <Button variant="contained" color="warning">Edit</Button>
                    <Button variant="contained" color="error">Batal</Button>
                  </ButtonGroup>
                  </TableCell>

                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
      </Box>


    </Box></>
  );
};

const bookingData = [{
  "id": 1,
  "username": "muhammad.hilmi",
  "referal": "ASC857113944282",
  "tanggalBooking": "28/04/2022",
  "jamBooking": "08.53",
  "status": "Selesai"
},{
  "id": 2,
  "username": "hilmi.albiruni",
  "referal": "HAB895392525133",
  "tanggalBooking": "23/05/2022",
  "jamBooking": "09.50",
  "status": "Proses"
},{
  "id": 3,
  "username": "isabelle.yansim",
  "referal": "ISY8187739373244",
  "tanggalBooking": "23/02/2022",
  "jamBooking": "10.47",
  "status": "Batal"
}]


export default ManagementKelasPage;